let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jozYS")).then(() => parcelRequire('kcSv9'));